import { Box } from "@gti-controls-v2/web-core";
import { ConsumosGrid } from "./components/ConsumosGrid";
import { ConsumosTabletFooter } from "./components/ConsumosTabletFooter";

export const ConsumosTablet = (props) => {
    return (
        <>
            <Box sx={{ p: 2 }}>
                <ConsumosGrid
                    consumos={props.consumos}
                    refreshConsumos={props.refreshConsumos}
                    hacerCorte={props.hacerCorte}
                    loading={props.loading} />
            </Box>

            <ConsumosTabletFooter cortes={props.cortes} />
        </>
    );
};

export default ConsumosTablet;
